import {useState} from 'react';
import {UseGetPostResult} from "../types/api";
import {getApiUrl} from "./useFetchPost";


const useGetPost = (): UseGetPostResult => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<any>(null);

    const getPost = async (postId: number) => {
        setIsLoading(true);
        setError(null);

        try {
            const apiUrl = getApiUrl();
            const response = await fetch(`${apiUrl}/post/${postId}`, {
                method: 'GET',
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
            }

            const result = await response.json();
            setData(result);
            console.log(result);
            return result;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Неизвестная ошибка';
            setError(errorMessage);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {getPost, isLoading, error, data};
};

export default useGetPost;